import { createApp } from 'vue';
import App from './App.vue';
import router from './views';
import Page from './components/Page.vue';
import MaterialIcons from './components/MaterialIcons.vue';
import AsyncImage from './components/AsyncImage.vue';

const app = createApp(App);

app.component('Page', Page);
app.component('MaterialIcons', MaterialIcons);
app.component('AsyncImage', AsyncImage);

app.use(router);
app.mount(document.body);
